import React from 'react';
import { Layout } from '@layout/Layout';
import ComingSoon from '@components/common/ComingSoon/ComingSoon';
import { Assessment as AssessmentIcon } from '@mui/icons-material';

const ReportsPage: React.FC = () => {
    return (
        <Layout>
            <ComingSoon
                title="Reports"
                description="Generate comprehensive reports and analytics. Get insights into your data with customizable charts, graphs, and detailed reporting tools."
                icon={<AssessmentIcon sx={{ fontSize: 60, color: '#9C27B0' }} />}
                color="#9C27B0"
                features={[
                    'Custom Reports',
                    'Data Visualization',
                    'Export Options',
                    'Scheduled Reports',
                    'Interactive Charts',
                    'Performance Metrics',
                    'Trend Analysis',
                    'PDF Generation'
                ]}
            />
        </Layout>
    );
};

export default ReportsPage;
